import type { AlertRule } from "../types";
import { AlertRuleEdit } from "./AlertRuleEdit";
import { AlertRuleList } from "./AlertRuleList";

/**
 * Almikia Epic ER (TASK-006): "Alertas" -- direccion-only (see each screen's
 * own `CanAccess` gate). No `create`/`show`/`delete`: the catalogue is fixed
 * by design (TASK-003's ADR) and the list already surfaces every field a
 * direccion user needs to decide whether to open a rule's edit form.
 */
export default {
  list: AlertRuleList,
  edit: AlertRuleEdit,
  recordRepresentation: (record: AlertRule) => record.label,
};
